module.exports = __webpack_public_path__ + "img/ico_7.1bffb9f9.png";